module.exports = __webpack_public_path__ + "img/tarj1-5.28256df8.svg";